// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"fba7e5f5","312":"045e4baa","360":"144c10e5","416":"b3b614eb","477":"dbb96137","568":"0105967d"}[chunkId] + ".chunk.css";
};